import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
// import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CognitoService } from '../../core/services/cognito.service';
import { ValidationService } from '../../core/services/validation.service';

@Component({
    selector: 'reset-password-component',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent {
    step = 'reset-your-password';
    isReset = true;
    email: string = 'nguyenmaungoc@gmail.com';
    newPassword: string;
    reNewPassword: string;
    code: string;
    isChangeCode: boolean = false;
    constructor(
        private router: ActivatedRoute,
        private cognitoService: CognitoService,
        private validationService: ValidationService,
    ) {}
    resetPassword(form: NgForm) {
        if (form.valid && this.newPassword == this.reNewPassword) {
            this.router.queryParams.subscribe(_params => {
                // const { confirmation_code, userName } = params;
                // const data = {
                //     ConfirmationCode: confirmation_code,
                //     UserName: userName,
                //     Password: this.newPassword,
                // };
                // this.apiService.changePassword(data).subscribe(
                //     res => {
                //         if (res.status) {
                //             this.ngxService.stop();
                //             this.step = 'reset-success';
                //             this.isReset = false;
                //         } else {
                //             this._snackBar.open(res.parameters.message, 'x', {
                //                 horizontalPosition: 'right',
                //                 verticalPosition: 'top',
                //                 panelClass: ['notif-error'],
                //                 duration: 3000,
                //             });
                //         }
                //     },
                //     () => {
                //         this.ngxService.stop();
                //     },
                // );
            });

            // this.ngxService.start();
            // this.cognitoService
            //     .forgotPassword(this.email)
            //     .then(() => {
            //         this.ngxService.stop();
            //         this.step = 'verify-code';
            //         this.isReset = false;
            //     })
            //     .catch(() => {
            //         this.ngxService.stop();
            //     });
        }
    }

    verifyCode() {
        this.isChangeCode = true;
        if (this.code?.length == 6) {
            this.step = 'reset-success';
            this.cognitoService.confirmPassword(this.email, this.code, this.newPassword);
        }
    }

    goBackSignIn() {
        window.location.href = './';
    }

    // this called every time when user changed the code
    onCodeChanged() {
        this.isChangeCode = true;
    }
    // this called only if user entered full code
    onCodeCompleted(code: string) {
        this.code = code;
    }

    validatorPassword: any = (c: any) => {
        return this.validationService.password(c);
    };
}
